function getEnv(key: string, defaultValue: string): string {
  // eslint-disable-next-line no-prototype-builtins
  if (!process.env.hasOwnProperty(key)) {
    return defaultValue;
  }
  return process.env[key];
}

function getRunEnv(): string {
  return getEnv('NODE_ENV', 'development');
}

function isKAERuntime(): boolean {
  const env: string = getRunEnv();
  return env === 'production' || env === 'test';
}

function isTestRuntime(): boolean {
  const env: string = getRunEnv();
  return env === 'development' || env === 'test';
}

const exportedFunctions = {
  getEnv,
  getRunEnv,
  isKAERuntime,
  isTestRuntime,
};

export default exportedFunctions;
